
{{loadFocustelements()}}
<div (keydown)="handleKeydown($event)">
  <div class="modal-header">
    <h2 id='modalHeading' tabindex="0">{{modalPopupObject.modalHeader}} </h2>
  </div>
  <div class="corner-button">
    <button class="close" aria-label="Close" (click)="btnAction(false)">x</button>
  </div>
  <div class="box-outer">
  <div *ngIf="modalPopupObject.modalSubHeader ?.length > 0">
    <h2>Exit {{modalPopupObject.modalSubHeader}} </h2>
  </div>
  <p [innerHtml]="modalPopupObject.modalMessage"></p>
  </div>
  <div class="text-right modal-footer">
    <div class="button-group">
      <a href="javascript:void(0)" role="button" class="btn btn-secondary pull-right" *ngIf="modalPopupObject.showConfirmButton" (click)="btnAction(true)" attr.aria-label="{{modalPopupObject.confirmButtonAccessibilityText}}">{{modalPopupObject.confirmButtonMessage}}</a>
      <a href="javascript:void(0)" class="btn btn-link" *ngIf="modalPopupObject.showCancelButton" (click)="btnAction(false)" attr.aria-label="{{modalPopupObject.cancelButtonMessage}}">{{modalPopupObject.cancelButtonMessage}}</a>
    </div>
      <div class="clearfix"></div>
  </div>
</div>
